var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { RibbonMessage, RibbonButton } from "./components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the HeaderRegulationRibbonHeaderRegulationRibbonBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
var HeaderRegulationRibbonMessageBlock = /** @class */ (function (_super) {
    __extends(HeaderRegulationRibbonMessageBlock, _super);
    function HeaderRegulationRibbonMessageBlock(props) {
        var _this = _super.call(this, props) || this;
        // setup dictionary
        _this.dict = _this.props.dict;
        // setup cms
        _this.cms = _this.props.cms;
        _this.message = _this.cms.Message;
        // setup data provider
        _this.state = {
            dataProvider: _this.props.dataProvider
        };
        return _this;
    }
    HeaderRegulationRibbonMessageBlock.prototype.renderButton = function () {
        return React.createElement(RibbonButton, { text: this.dict[this.state.dataProvider.chooseBtnText], handler: this.state.dataProvider.changeExpanded, modifier: this.state.dataProvider.chooseModifier });
    };
    /* istanbul ignore next */
    HeaderRegulationRibbonMessageBlock.prototype.render = function () {
        var expandedClass = this.state.dataProvider.isExpanded ? "" : "not-expanded";
        var isHiddenClass = this.state.dataProvider.shouldHide && this.message === "" ? "isHidden" : "";
        var message = this.getMessageText();
        return (React.createElement("div", { className: "rj-ribbon__main-container " + isHiddenClass },
            React.createElement(RibbonMessage, { className: "rj-ribbon__message " + expandedClass, handler: this.state.dataProvider.changeExpanded, message: message, resizeHandler: this.state.dataProvider.winResizeHandler }),
            this.state.dataProvider.hasButton === true && this.renderButton()));
    };
    HeaderRegulationRibbonMessageBlock.prototype.getMessageText = function () {
        if (this.message) {
            return this.message;
        }
        else {
            return this.state.dataProvider.message.messageText;
        }
    };
    HeaderRegulationRibbonMessageBlock = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], HeaderRegulationRibbonMessageBlock);
    return HeaderRegulationRibbonMessageBlock;
}(React.Component));
export { HeaderRegulationRibbonMessageBlock };
//# sourceMappingURL=HeaderRegulationRibbonMessageBlock.js.map